import React from "react";
import { cn } from "~/utils";

const InvoiceItem = ({ className, item, value }) => (
  <div className={cn("flex flex-col", className)}>
    <span className="text-xs text-slate-400">{item}</span>
    <span className="text-sm font-semibold text-slate-500">{value}</span>
  </div>
);

export default InvoiceItem;
